// = Libs =

// = Helpers =

import useSWR from 'swr';
import sendRequest from '@/helpers/sendRequest';

export interface OrgShort {
  orgID: number;
  name: string;
}

interface OrgBE {
  'organizationId': number;
  'attributes': {
    'title': string | { value: string }; //TODO: убрать на бэке выдачу метаданных атрибутов
    'type': string;
    'eiopId': number;
  };
  'title'?: string;
}

const mapToOrgShort = (orgBE: OrgBE): OrgShort => {
  return {
    orgID: orgBE.organizationId,
    name:
      (orgBE.attributes?.title as { value: string })?.value ||
      (orgBE.attributes?.title as string) ||
      (orgBE.title as string),
  };
};

const useSubordinates = (orgID: string | number) => {
  const { data, error } = useSWR(
    `monitoring-api/organizations/${orgID}/subordinates/`
  );

  if (!data) return error;

  return data.items.map(mapToOrgShort);
};

const getSubordinates = async (orgID: string | number) => {
  const { error, data } = await sendRequest<{ items: OrgBE[] }>({
    url: `monitoring-api/organizations/${orgID}/subordinates/`,
    method: 'get',
  })
    .then((res) => res)
    .catch((err) => err);

  return data.items.map(mapToOrgShort);
};

const useOrgList = () => {
  // TODO: сделать адекватный хэндлинг ошибок
  const author = useSWR('monitoring-api/organizations/?type=author')?.data;
  const executor = useSWR('monitoring-api/organizations/?type=executor')?.data;

  const { error } = useSWR('monitoring-api/organizations/?type=executor');

  if (!(author && executor)) return error;

  return {
    'executor': executor.items.map(mapToOrgShort),
    'author': author.items.map(mapToOrgShort),
  };
};

const useOrgData = (orgId: number | string): OrgShort => {
  const { data, error } = useSWR(`monitoring-api/organizations/${orgId}`);

  if (!data) return error;

  return mapToOrgShort(data);
};

export { useOrgList, useOrgData, useSubordinates, getSubordinates };
